import { render, staticRenderFns } from "./serial.form.vue?vue&type=template&id=0bf1912f&"
import script from "./serial.form.vue?vue&type=script&lang=js&"
export * from "./serial.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports